// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.securepayLink {
    display: flex;
    width: 100%;
    justify-content: flex-end;
}

.securepayLink a {
    color: #DC1928;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/componentStyles/securepayStyles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".securepayLink {\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n}\n\n.securepayLink a {\n    color: #DC1928;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
